var map = {
	"./admin/admin.module": [
		"./src/app/pages/admin/admin.module.ts",
		"admin-admin-module~app-pages-pages-module~ativos-bolsa-ativos-bolsa-module~cadastros-cadastros-modul~083ffe79",
		"admin-admin-module~ativos-bolsa-ativos-bolsa-module~dashboard-dashboard-module~financeiro-financeiro~a64849ff",
		"admin-admin-module~app-pages-pages-module",
		"common",
		"admin-admin-module"
	],
	"./ativos-bolsa/ativos-bolsa.module": [
		"./src/app/pages/ativos-bolsa/ativos-bolsa.module.ts",
		"admin-admin-module~app-pages-pages-module~ativos-bolsa-ativos-bolsa-module~cadastros-cadastros-modul~083ffe79",
		"admin-admin-module~ativos-bolsa-ativos-bolsa-module~dashboard-dashboard-module~financeiro-financeiro~a64849ff",
		"common",
		"ativos-bolsa-ativos-bolsa-module"
	],
	"./cadastros/cadastros.module": [
		"./src/app/pages/cadastros/cadastros.module.ts",
		"admin-admin-module~app-pages-pages-module~ativos-bolsa-ativos-bolsa-module~cadastros-cadastros-modul~083ffe79",
		"cadastros-cadastros-module~clientes-clientes-module~clientes-juridico-clientes-juridico-module~colab~3c79c433",
		"app-pages-pages-module~cadastros-cadastros-module~clientes-clientes-module~financeiro-financeiro-mod~006de42e",
		"common",
		"cadastros-cadastros-module"
	],
	"./clientes-juridico/clientes-juridico.module": [
		"./src/app/pages/clientes-juridico/clientes-juridico.module.ts",
		"admin-admin-module~app-pages-pages-module~ativos-bolsa-ativos-bolsa-module~cadastros-cadastros-modul~083ffe79",
		"cadastros-cadastros-module~clientes-clientes-module~clientes-juridico-clientes-juridico-module~colab~3c79c433",
		"app-pages-pages-module~clientes-clientes-module~clientes-juridico-clientes-juridico-module~negocios-~2895b3c7",
		"app-pages-pages-module~clientes-clientes-module~clientes-juridico-clientes-juridico-module",
		"clientes-juridico-clientes-juridico-module~negocios-juridico-negocios-juridico-module",
		"common",
		"clientes-juridico-clientes-juridico-module"
	],
	"./clientes/clientes.module": [
		"./src/app/pages/clientes/clientes.module.ts",
		"admin-admin-module~app-pages-pages-module~ativos-bolsa-ativos-bolsa-module~cadastros-cadastros-modul~083ffe79",
		"cadastros-cadastros-module~clientes-clientes-module~clientes-juridico-clientes-juridico-module~colab~3c79c433",
		"app-pages-pages-module~clientes-clientes-module~clientes-juridico-clientes-juridico-module~negocios-~2895b3c7",
		"app-pages-pages-module~cadastros-cadastros-module~clientes-clientes-module~financeiro-financeiro-mod~006de42e",
		"app-pages-pages-module~clientes-clientes-module~negocios-negocios-module",
		"app-pages-pages-module~clientes-clientes-module~clientes-juridico-clientes-juridico-module",
		"app-pages-pages-module~clientes-clientes-module",
		"common",
		"clientes-clientes-module"
	],
	"./colaboradores/colaboradores.module": [
		"./src/app/pages/colaboradores/colaboradores.module.ts",
		"admin-admin-module~app-pages-pages-module~ativos-bolsa-ativos-bolsa-module~cadastros-cadastros-modul~083ffe79",
		"cadastros-cadastros-module~clientes-clientes-module~clientes-juridico-clientes-juridico-module~colab~3c79c433",
		"common",
		"colaboradores-colaboradores-module"
	],
	"./dashboard/dashboard.module": [
		"./src/app/pages/dashboard/dashboard.module.ts",
		"admin-admin-module~app-pages-pages-module~ativos-bolsa-ativos-bolsa-module~cadastros-cadastros-modul~083ffe79",
		"admin-admin-module~ativos-bolsa-ativos-bolsa-module~dashboard-dashboard-module~financeiro-financeiro~a64849ff",
		"common",
		"dashboard-dashboard-module"
	],
	"./financeiro/financeiro.module": [
		"./src/app/pages/financeiro/financeiro.module.ts",
		"admin-admin-module~app-pages-pages-module~ativos-bolsa-ativos-bolsa-module~cadastros-cadastros-modul~083ffe79",
		"cadastros-cadastros-module~clientes-clientes-module~clientes-juridico-clientes-juridico-module~colab~3c79c433",
		"admin-admin-module~ativos-bolsa-ativos-bolsa-module~dashboard-dashboard-module~financeiro-financeiro~a64849ff",
		"app-pages-pages-module~cadastros-cadastros-module~clientes-clientes-module~financeiro-financeiro-mod~006de42e",
		"common",
		"financeiro-financeiro-module"
	],
	"./negocios-juridico/negocios-juridico.module": [
		"./src/app/pages/negocios-juridico/negocios-juridico.module.ts",
		"admin-admin-module~app-pages-pages-module~ativos-bolsa-ativos-bolsa-module~cadastros-cadastros-modul~083ffe79",
		"cadastros-cadastros-module~clientes-clientes-module~clientes-juridico-clientes-juridico-module~colab~3c79c433",
		"app-pages-pages-module~clientes-clientes-module~clientes-juridico-clientes-juridico-module~negocios-~2895b3c7",
		"clientes-juridico-clientes-juridico-module~negocios-juridico-negocios-juridico-module",
		"common",
		"negocios-juridico-negocios-juridico-module"
	],
	"./negocios/negocios.module": [
		"./src/app/pages/negocios/negocios.module.ts",
		"admin-admin-module~app-pages-pages-module~ativos-bolsa-ativos-bolsa-module~cadastros-cadastros-modul~083ffe79",
		"cadastros-cadastros-module~clientes-clientes-module~clientes-juridico-clientes-juridico-module~colab~3c79c433",
		"app-pages-pages-module~clientes-clientes-module~clientes-juridico-clientes-juridico-module~negocios-~2895b3c7",
		"app-pages-pages-module~clientes-clientes-module~negocios-negocios-module",
		"common",
		"negocios-negocios-module"
	],
	"app/pages/pages.module": [
		"./src/app/pages/pages.module.ts",
		"admin-admin-module~app-pages-pages-module~ativos-bolsa-ativos-bolsa-module~cadastros-cadastros-modul~083ffe79",
		"app-pages-pages-module~clientes-clientes-module~clientes-juridico-clientes-juridico-module~negocios-~2895b3c7",
		"app-pages-pages-module~cadastros-cadastros-module~clientes-clientes-module~financeiro-financeiro-mod~006de42e",
		"app-pages-pages-module~clientes-clientes-module~negocios-negocios-module",
		"app-pages-pages-module~clientes-clientes-module~clientes-juridico-clientes-juridico-module",
		"app-pages-pages-module~clientes-clientes-module",
		"admin-admin-module~app-pages-pages-module",
		"common",
		"app-pages-pages-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error('Cannot find module "' + req + '".');
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var module = __webpack_require__(ids[0]);
		return module;
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;